module.exports = clamp

function clamp(value, min, max) {
  return min < max
    ? (value < min ? min : value > max ? max : value)
    : (value < max ? max : value > min ? min : value)
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/clamp/index.js
 ** module id = 10
 ** module chunks = 0
 **/